module.exports = __webpack_public_path__ + "assets/img/bed023f48d3510e393aa230a0cd1c6b2.svg";